module.exports = __webpack_public_path__ + "img/minus.426f9d6c.svg";